var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline',{attrs:{"align-top":"","dense":""}},_vm._l((_vm.updates),function(item,i){return _c('Update',{key:'update-item-'+i,attrs:{"item":item,"payment_methods":_vm.payment_methods,"statuses":_vm.statuses}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }